import { fetchPlanogram as fetchPlanogramAPIRequest } from '../utils/api';

export const FETCHING_PLANOGRAM = 'FETCHING_PLANOGRAM';
export const FETCHED_PLANOGRAM = 'FETCHED_PLANOGRAM';
export const PLANOGRAM_ERROR = 'PLANOGRAM_ERROR';
export const PLANOGRAM_UPDATE = 'PLANOGRAM_UPDATE';

/**
 * fetch planogram for the provided devicecode
 * @param {*} deviceCode
 * @returns
 */
export const fetchPlanogram = (deviceCode, group) => async dispatch => {
  try {
    dispatch({ type: FETCHING_PLANOGRAM });
    const response = await fetchPlanogramAPIRequest(deviceCode, group);

    // if the response has a proper data structure, save it to the store
    if (response && 'shelves' in response && 'shelvesCount' in response) {
      dispatch({
        type: FETCHED_PLANOGRAM,
        data: response,
      });
    } else {
      dispatch({
        type: FETCHED_PLANOGRAM,
        data: null,
      });
    }
  } catch (error) {
    dispatch({
      type: PLANOGRAM_ERROR,
      error: error,
    });
  }
};

/**
 * update the planogram when product is assigned to the slot
 * @param {*} productId
 * @param {*} shelfNumber
 * @param {*} slot
 * @returns
 */
export const updatePlanogram = (
  product,
  shelfNumber,
  slot
) => async dispatch => {
  try {
    if (!product) return;

    dispatch({
      type: PLANOGRAM_UPDATE,
      product,
      shelfNumber,
      slot,
    });
  } catch (error) {
    console.error(error);
  }
};
